const cards = {
  cards: 'Credenciales',
  search_by_organization_or_site: 'Credencial, Usuario asignado',
  search_by_user: 'Credencial',
  options: 'Opciones',
  general_information: 'Información general',
  assign_user: 'Asignar Usuario',
  assigned_user: 'Usuario asignado',
  assign_msg: '¿Quieres asignar la credencial {{ card }} a {{ user }}?',
  assign_reader:
    '¿Quieres escanear con lector {{ reader }} del sitio {{ site }}?',
  delete_msg: 'Desea eliminar la tarjeta {{ card }}?',
  unassign_msg: '¿Quieres desasignar {{ user }} de la credencial {{ card }}?',
  delete_card_multiple_sites:
    'Nota: esta credencial está asociada a varios sitios y se eliminará de todos ellos.',
  readers: 'Lectores',
  scan_card: 'Escanear credencial',
  search_devices: 'Buscar Dispositivos',
  scan_status: 'Estado de escaneo: ',
  enrolled: 'Inscrita',
  discover: 'Descubrir KPROG',
  use_kprog: 'Usar KPROG',
  kprog: 'KPROG',
  table: {
    card: 'CREDENCIALES',
    state: 'ESTADO',
    user_name: 'NOMBRE',
    reader: 'LECTOR',
    site: 'SITIO',
  },
  form: {
    display_name: 'Nombre para mostrar',
    facility_code: 'Código de instalación',
    card_code: 'Código de tarjeta',
    activation_date: 'Fecha de activacion',
    expiry_date: 'Fecha de caducidad',
    card_format: 'Formato de credencial',
    card_number_hex: 'Número de credencial hexadecimal',
    all: 'Todo',
    stolen: 'Robado',
    lost: 'Perdido',
    status: 'Estado',
    select_a_reader: 'Seleccione un lector',
    csn: 'C.S.N. (número impreso)',
    registration_code: 'Código de Registro',
  },
  pin_option: {
    not_used: 'No utilizado',
    start_lockdown: 'Iniciar bloqueo',
    stop_lockdLock: 'Detener el bloqueo',
    lockdown_grant: 'El bloqueo otorga acceso',
    area_secured: 'Mantener la puerta segura (mantener el bloqueo)',
  },
  list: {
    column_credential_number: 'Número de credencial',
    column_csn: 'CSN',
    column_facility_code: 'Código de instalación',
    column_credential_id: 'ID de credencial',
    column_assigned_user: 'Usuario asignado',
    column_lockdown: 'Opción de bloqueo',
    column_stolen: 'Robado',
    column_lost: 'Perdido',
    lockdown_display: {
      not_used: 'Ninguna',
      start: 'Desactivado durante el bloqueo',
      stop: 'Detener bloqueo',
      grant_access: 'Omitir durante el bloqueo',
      maintain: 'Mantener la puerta asegurada',
    },
    pill_stolen: 'Robado',
    pill_lost: 'Perdido',
  },
};

export default cards;
